// This document was created with assistance from AI tool, co-pilot, but the content 
// has been reviewed and edited by Lalith.

// Accept both legacy JSON-stringified tokens and plain token strings.
export const normalizeCustomerToken = (value) => {
    if (typeof value !== 'string') return null;

    let token = value.trim();
    try {
        token = JSON.parse(token);
    } catch {
        // Plain tokens are not necessarily valid JSON.
    }

    if (typeof token !== 'string') return null;

    token = token.trim();
    if (!token || /^(undefined|null)$/i.test(token) || /["\r\n]/.test(token)) {
        return null;
    }

    return token;
};

export const getCustomerToken = () => {
    return normalizeCustomerToken(localStorage.getItem('cusToken'));
};

export const getEncKeyHeader = () => {
    const token = getCustomerToken();
    return token ? `Bearer ${token}` : null;
};